import { BREAKPOINTS } from '../utils/constants';

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const mobileMediaQuery = window.matchMedia(`(max-width: ${BREAKPOINTS.DESKTOP}px)`);
  const variantInputEls = document.querySelectorAll('[data-variant-input]');
  const sellingPlanInputEls = document.querySelectorAll('[data-selling-plan-radio]');
  const productControlsEl = document.querySelector('[data-product-controls]');
  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const selectEls = stickyAtc.querySelectorAll('[data-product-sticky-atc-select]');
  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form.querySelector('button[type="submit"]');
  const allInputEls = [...variantInputEls, ...sellingPlanInputEls];

  const syncButtons = () => {
    for (const name of stickyAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.removeAttribute(name);
      }
    }
    for (const name of mainAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.setAttribute(name, mainAtcButton.getAttribute(name));
      }
    }
    stickyAtcButton.innerHTML = mainAtcButton.innerHTML;
  };

  const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const containerBottom = getBottom(productControlsEl);
    if (scrollY >= containerBottom) {
      stickyAtc.classList.remove('hidden');
    } else {
      stickyAtc.classList.add('hidden');
    }
  };

  const handleStickyAtcClick = () => {
    mainAtcButton.click();
  };

  const updateStickySelect = (variantInput) => {
    if (variantInput.checked === true) {
      selectEls.forEach(select => {
        if (select.name.includes(variantInput.name)) {
          select.value = variantInput.value;
        }
      });
    }
  };

  const updateStickyAtcVariant = (event) => {
    const target = event.target;
    allInputEls.forEach((inputEl) => {
      if (inputEl.value === target.value && target.name.includes(inputEl.name)) {
        inputEl.checked = true;
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const handleVariantInputChange = (event) => {
    updateStickySelect(event.target);
  };

  let mainAtcBtnObserver = null;

  const enableStickyAtc = () => {
    mainAtcBtnObserver = new MutationObserver(syncButtons);
    syncButtons();
    mainAtcBtnObserver.observe(mainAtcButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    if (productControlsEl) {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    stickyAtcButton.addEventListener('click', handleStickyAtcClick);

    if (!allInputEls.length) return;

    allInputEls.forEach(inputEl => {
      updateStickySelect(inputEl);
      inputEl.addEventListener('change', handleVariantInputChange);
    });
    selectEls.forEach(select => select.addEventListener('change', updateStickyAtcVariant));
  };

  const disableStickyAtc = () => {
    if (mainAtcBtnObserver) {
      mainAtcBtnObserver.disconnect();
      mainAtcBtnObserver = null;
    }
    window.removeEventListener('scroll', handleScroll);
    stickyAtcButton.removeEventListener('click', handleStickyAtcClick);
    allInputEls.forEach(inputEl => {
      inputEl.removeEventListener('change', handleVariantInputChange);
    });
    selectEls.forEach(select => select.removeEventListener('change', updateStickyAtcVariant));
  };

  const handleMediaChange = (event) => {
    if (event.matches) {
      enableStickyAtc();
    } else {
      disableStickyAtc();
    }
  };

  handleMediaChange(mobileMediaQuery);
  mobileMediaQuery.addEventListener('change', handleMediaChange);
};

export default initProductStickyAtc;
